import NewPriceIcon from '~/icons/NewPriceIcon';
import formatAndDropDecimal from '~/utilities/formatAndDropDecimal';

type Props = {
  discountedPrice: number;
  showNewPriceIcon?: boolean;
};

export default function Price({ discountedPrice, showNewPriceIcon }: Props) {
  return (
    <div
      data-qa="price"
      className="-mb-[2px] flex font-bold gap-8 items-center text-2xl text-blue-6"
    >
      {showNewPriceIcon && (
        <NewPriceIcon className="!h-20 !w-20" data-qa="new-price-icon" />
      )}
      ${formatAndDropDecimal(discountedPrice)}
    </div>
  );
}
